import React, { useCallback, useContext } from 'react';
import { KPI_GROUP_ROW_HEIGHT } from './KpiRowRight/constants';
import ScorecardContext from 'contexts/ScorecardContext';

const GroupingRowRight = ({ kpiId }: { kpiId: string }) => {
  const { setHoveredKpiId } = useContext(ScorecardContext);
  const onKpiMouseEnter = useCallback(() => {
    setHoveredKpiId(kpiId);
  }, [kpiId, setHoveredKpiId]);
  return (
    <div
      onMouseEnter={onKpiMouseEnter}
      style={{
        height: `${KPI_GROUP_ROW_HEIGHT}px`,
        width: '100%',
        backgroundColor: 'var(--color-bg-sunken)',
        borderBottom: `1px solid var(--color-grid-border)`,
        borderRight: `1px solid var(--color-grid-border)`,
      }}
    ></div>
  );
};

export default GroupingRowRight;
